export { required as required };
export { email as email };
export { min as min };
export { max as max };
export { confirmed as confirmed };
export { regex as regex };
export { between as between };
export { alpha as alpha };
export { integer as integer };
export { digits as digits };
export { alphaDash as alphaDash };
export { alphaNum as alphaNum };
export { length as length };
export { positive as positive };
export { credit as credit };
export { password as password };
export { url as url };
export { txHash as txHash };
export { IPV4_6 as IPV4_6 };
export { minAmount as minAmount };
export { maxAmount as maxAmount };
export { minAmountQuantity as minAmountQuantity };
export { maxAmountQuantity as maxAmountQuantity };
export { minQuantity as minQuantity };
export { maxQuantity as maxQuantity };
export { minOrderLimit as minOrderLimit };
export { maxOrderLimit as maxOrderLimit };
export { maxSelectionRule as maxSelectionRule };
export { txAddress as txAddress };
import * as veevalidate from 'vee-validate';
import * as veevalidate_dist_rules from 'vee-validate/dist/rules';
import locales_en from './locales/en';
import locales_ru from './locales/ru';
import locales_es from './locales/es';
import validators from './validators';








// ////////////////////////////////////////////////////////
// General
// ////////////////////////////////////////////////////////

const required = veevalidate.extend("required", veevalidate_dist_rules["required"]);
const email = veevalidate.extend("email", veevalidate_dist_rules["email"]);
const min = veevalidate.extend("min", veevalidate_dist_rules["min"]);
const max = veevalidate.extend("max", veevalidate_dist_rules["max"]);
const confirmed = veevalidate.extend("confirmed", veevalidate_dist_rules["confirmed"]);
const regex = veevalidate.extend("regex", veevalidate_dist_rules["regex"]);
const between = veevalidate.extend("between", veevalidate_dist_rules["between"]);
const alpha = veevalidate.extend("alpha", veevalidate_dist_rules["alpha"]);
const integer = veevalidate.extend("integer", veevalidate_dist_rules["integer"]);
const digits = veevalidate.extend("digits", veevalidate_dist_rules["digits"]);
const alphaDash = veevalidate.extend("alpha-dash", veevalidate_dist_rules["alpha_dash"]);
const alphaNum = veevalidate.extend("alpha-num", veevalidate_dist_rules["alpha_num"]);
const length = veevalidate.extend("length", veevalidate_dist_rules["length"]);
const positive = veevalidate.extend("positive", {
  validate: validators["validatorPositive"],
  message: "Please enter positive number!"
});
const credit = veevalidate.extend("credit-card", {
  validate: validators["validatorCreditCard"],
  message: "It is not valid credit card!"
});
const password = veevalidate.extend("password", {
  validate: validators["validatorPassword"],
  message: "Your {_field_} must contain at least one uppercase, one lowercase, one special character, one digit, and be at least 8 characters long"
});
const url = veevalidate.extend("url", {
  validate: validators["validatorUrlValidator"],
  message: "URL is invalid"
});
const txHash = veevalidate.extend("txHash", {
  validate: validators["validatorTxHash"]
});
const IPV4_6 = veevalidate.extend("IPV4_6", {
  validate: validators["validatorIPV4_6"]
});
const minAmount = veevalidate.extend("minAmount", {
  validate: validators["validatorMinAmount"]
});
const maxAmount = veevalidate.extend("maxAmount", {
  validate: validators["validatorMaxAmount"]
});
const minAmountQuantity = veevalidate.extend("minAmountQuantity", {
  validate: validators["validatorMinAmountQuantity"]
});
const maxAmountQuantity = veevalidate.extend("maxAmountQuantity", {
  validate: validators["validatorMaxAmountQuantity"]
});
const minQuantity = veevalidate.extend("minQuantity", {
  validate: validators["validatorMinQuantity"]
});
const maxQuantity = veevalidate.extend("maxQuantity", {
  validate: validators["validatorMaxQuantity"]
});
const minOrderLimit = veevalidate.extend("minOrderLimit", {
  validate: validators["validatorMinOrderLimit"]
});
const maxOrderLimit = veevalidate.extend("maxOrderLimit", {
  validate: validators["validatorMaxOrderLimit"]
});
const maxSelectionRule = veevalidate.extend("maxSelectionRule", {
  validate: validators["validatorMaxSelectionRule"]
});
const txAddress = veevalidate.extend("txAddress", {
  validate: validators["validateAddress"]
});
// Install localizations.
veevalidate.localize({
  en: locales_en,
  ru: locales_ru,
  es: locales_es
});
veevalidate.localize(localStorage.getItem("appLocale") || "en");
// ////////////////////////////////////////////////////////
// NOTE:
// Quasar validation for reference only
// Remove this note once development is finished and make sure to
// to convert all of them in veevalidate version
// ////////////////////////////////////////////////////////

// export const required = (val) => {
//   return (val && val.length > 0) || '*Field is required'
// }

// export const required_obj = (obj) => {
//   if (obj === null || obj === undefined) return '*Field is required'
//   return (Object.entries(obj).length > 0 && obj.constructor === Object) || '*Field is required'
// }

// export const no_blank_spaces_arr = (arr) => {
//   return arr.every(val => (val.trim() && val.trim().length > 0)) || 'Blank Spaces are not allowed'
// }

// export const url = val => {
//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   // Used
//   // https://stackoverflow.com/questions/4314741/url-regex-validation

//   // Other
//   // https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url
//   // https://www.w3resource.com/javascript-exercises/javascript-regexp-exercise-9.php
//   // https://www.geeksforgeeks.org/how-to-validate-url-using-regular-expression-in-javascript/

//   /* eslint-disable no-useless-escape */
//   const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
//   /* eslint-enable no-useless-escape */
//   return re.test(val) || 'URL is invalid'
// }

// export const date = val => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   // https://github.com/quasarframework/quasar/blob/dev/ui/src/utils/patterns.js
//   return /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(val) || 'Date is invalid'
// }

// export const max = (val, max) => {

//   // If blank return
//   if (val === undefined || val === null) return true

//   return val.length <= max || `More than ${max} characters are not allowed`
// }

// export const max_arr = (val, max) => {
//   return val.length <= max || `More than ${max} values are not allowed`
// }

// export const min = (val, min) => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   return val.length >= min || `Minimum ${min} characters are required`
// }

// export const num_range = (val, min, max) => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   const msg = 'Value is invalid'
//   if (min === null) return val <= max || msg
//   else if (max === null) return val >= min || msg
//   else return (val >= min && val <= max) || msg
// }

export default { required, email, min, max, confirmed, regex, between, alpha, integer, digits, alphaDash, alphaNum, length, positive, credit, password, url, txHash, IPV4_6, minAmount, maxAmount, minAmountQuantity, maxAmountQuantity, minQuantity, maxQuantity, minOrderLimit, maxOrderLimit, maxSelectionRule, txAddress };
